export default "__VITE_ASSET__B$7A6ycp__"